import { Outlet, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePageConfig } from '@/contexts/PageConfigContext';
import Error404 from '@/components/Error404';

/**
 * Route guard that validates URL params are numeric IDs.
 * Inside AppLayout — configures layout via usePageConfig for 404 state.
 */
const NUMERIC_PARAMS = ['id', 'tournamentId', 'matchId', 'userId'];

const ValidatedRoute = () => {
  const { t } = useTranslation('common');
  const params = useParams();

  const hasInvalidParam = NUMERIC_PARAMS.some(paramName => {
    const value = params[paramName];
    return value && isNaN(Number(value));
  });

  usePageConfig(
    hasInvalidParam
      ? { title: t('notFound'), showBottomNav: false, showNavigation: false }
      : undefined
  );

  if (hasInvalidParam) {
    return <Error404 />;
  }

  return <Outlet />;
};

export default ValidatedRoute;
